import { useTranslation } from 'react-i18next';
import type { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';

export const useSourceSystemLinkLabel = (
  sourceSystem: WorkIntegration_Keys | undefined,
): string => {
  const { t } = useTranslation();
  return sourceSystem
    ? t(($) => $.common.settings['work-integrations'].viewInSource[sourceSystem])
    : t(($) => $.common.settings['work-integrations'].viewExternal);
};
